import React, { Component } from 'react';
import { Tab, TabList } from 'react-tabs';

import Container from './styles';

class Tabs extends Component {
  state = {
    items: [
      'Todos os pedidos',
      'Pendentes',
      'Confirmados',
      'Saiu para entrega',
      'Entregues',
      'Cancelados',
    ],
  }

  render() {
    const { items } = this.state;
    const { selected } = this.props;

    return (
      <Container id="tabs-component">
        <TabList className="tab-item">
          {items.map((item, index) => (
            <Tab key={index.toString()} className={selected.get(index) ? 'selected' : ''}>
              <span>{item}</span>
            </Tab>
          ))}
        </TabList>
      </Container>
    );
  }
}
export default Tabs;
